<template>
  <b-form @submit="onSubmit" class="modal-cost-view-wrap">

    <!-- MAIN -->
    <div class="mastermodal-view-wrap">
      <div class="mastermodal-view--left">

        <div v-if="isEdit && viewTabs" class="modal-form-viewselector">
          <GekkoButton
            @click.prevent="detailView = 'details'"
            :text="$gettext('Details')"
            :variant="(detailView === 'details') ? 'primary' : 'light'"
          />
          <GekkoButton
            @click.prevent="detailView = 'history'"
            :text="$gettext('History')"
            :variant="(detailView === 'history') ? 'primary' : 'light'"
          />
        </div>

        <div class="mastermodal-mobile-status">
          <CostStatusBadge :cost="cost" @toggle-complete="toggleComplete" />
        </div>

        <!-- left content here -->
        <overlay-scrollbars :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' }, className : 'os-theme-dark os-theme-gekko' }">
          <div v-if="detailView === 'history'">
            <TimelineWidget :widget="{ config: { object_type: 'cost', cost_id: cost.id } }" />
          </div>
          <div v-if="detailView === 'details'" class="mastermodal-view-tabs--details">
            <b-form-row>
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                  <template slot="label">
                    {{ $gettext('Cost date') }} <span v-if="showAIfieldsDate" class='ai-icon'>Ai</span>
                  </template>
                  <b-form-datepicker id="input-1" class="inline-form-datepicker" v-model="cost.date" no-flip initial-date="2021-01-01" :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" :label="$gettext('Cost number*')" label-for="input-2">
                  <b-form-input data-analytics-click id="input-2" v-model="cost.number" required :placeholder="$gettext('2020-000001')" @input="costNumberChange" />
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-group v-if="showField('number_on_document')" id="input-group-3" label-class="gk-label-margin gk-modal-label" :label="$gettext('Number on document')" label-for="input-3">
              <b-form-input data-analytics-click id="input-3" v-model="cost.number_on_document" />
            </b-form-group>

            <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
              <template slot="label">
                {{ $gettext('Supplier') }} <span v-if="showAIfieldsSupplier" class='ai-icon'>Ai</span>
              </template>
              <b-form-group>
                <CustomerSelector v-model="cost.supplier" :filters="{is_supplier:'True', owner_company: currentCompany.id, is_archived:'False'}" />
              </b-form-group>
            </b-form-group>

            <div class="modal-form-legend">
              <legend v-translate>Amounts</legend>
            </div>

            <b-form-group v-if="showField('amount')" id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
              <template slot="label">
                {{ $gettext('Total (inc. VAT)') }} <span v-if="showAIfieldsAmount" class='ai-icon'>Ai</span>
              </template>
              <b-input-group>
                <!-- <b-form-input id="input-5" type="number" v-model="cost.amount" placeholder="0.0" step="0.01" /> -->

                <NumberInput v-model.number="cost.amount" />
                
              </b-input-group>
            </b-form-group>

            <b-form-group v-if="showField('subtotal_amount')" id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
              <template slot="label">
                {{ $gettext('Total (ex. VAT)') }} <span v-if="showAIfieldsAmount" class='ai-icon'>Ai</span>
              </template>
              <b-input-group>
                <b-form-input id="input-5" type="number" v-model="cost.subtotal_amount" placeholder="0.0" step="0.01" />
              </b-input-group>
            </b-form-group>

            <b-form-row>
              <b-col v-for="a_cost_line, index in cost.cost_lines" :key="'taxrate-' + index" cols="12" :lg="(cost.cost_lines.length % 2 != 0 && (index == (cost.cost_lines.length - 1))) ? 12 : 6">
                <b-form-group id="input-group-7" class="vat-input-size" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                  <template slot="label">
                    {{ $gettext('VAT') + ' ' + a_cost_line.tax_rate + '%' }} <span v-if="showAIfieldsVAT" class='ai-icon'>Ai</span>
                  </template>
                  <b-input-group>
                    <template #append>
                      <b-input-group-text class="btn" @click="calculate(a_cost_line)" :disabled="disableTaxFields()">
                        <font-awesome-icon icon="fa-regular fa-calculator" class="append-icon" />
                      </b-input-group-text>
                    </template>
                    <b-form-input id="input-7" type="number" v-model="a_cost_line.amount" placeholder="0.0" step="0.01" :disabled="disableTaxFields()" />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="12" lg="6">
                <b-form-group v-if="showField('retention')" id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Retention')" label-for="input-6">
                  <b-input-group append="%">
                    <b-form-input data-analytics-click id="input-6" type="number" v-model="cost.retention_tax_percentage" :placeholder="$gettext('15.0%')" step="0.01" :disabled="disableTaxFields()" />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group v-if="showField('retention')" id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Amount')" label-for="input-6">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text class="btn" @click="calculateRetentionAmount" :disabled="disableTaxFields()">
                        <font-awesome-icon icon="fa-regular fa-calculator" class="append-icon" />
                      </b-input-group-text>
                    </template>
                    <b-form-input id="input-6" type="number" v-model="cost.retention_tax_amount" placeholder="0.0" step="0.01" :disabled="disableTaxFields()" />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-row>
              <b-col>
                <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label">
                  <b-form-checkbox id="input-8" class="checkbox-bg-color" style="font-size: 14px;" v-model="cost.tax_exempt" :disabled="cost.btw_reversed_charge" switch>
                    <span v-translate>Exempt from tax</span>&nbsp;
                    <span v-b-tooltip.hover :title="$gettext('Indicates that no VAT/sales tax will be paid on this cost item.')">
                      <font-awesome-icon icon="fa-regular fa-circle-question" class="tooltip-icon tooltip-icon--question" />
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="input-group-9" label-class="gk-label-margin gk-modal-label">
                  <b-form-checkbox id="input-9" class="checkbox-bg-color" style="font-size: 14px;" v-model="cost.btw_reversed_charge" :disabled="cost.tax_exempt" switch>
                    <span v-translate>Reversed charge</span>&nbsp;
                    <span v-b-tooltip.hover :title="$gettext('Indicates that no VAT/sales tax has been paid yet on this item. The buyer is responsible to account and report unpaid VAT/sales tax.')">
                      <font-awesome-icon icon="fa-regular fa-circle-question" class="tooltip-icon tooltip-icon--question" />
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="modal-form-legend">
              <legend v-translate>Categories</legend>
            </div>
            <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" :label="$gettext('Description')" label-for="input-4">
              <b-form-input data-analytics-click id="input-4" v-model="cost.description" :placeholder="$gettext('Lunch, new laptop, business cards')" />
            </b-form-group>

            <b-form-row>
              <b-col v-if="!transactionCost" cols="12" lg="6">
                <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Payment type')" label-for="input-10">
                  <PaymentTypeSelector v-model="cost.payment_type" />
                </b-form-group>
              </b-col>
                <b-col cols="12" :lg="(!transactionCost) ? 6 : 12">
                  <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Cost type*')" label-for="input-6">
                    <CostTypeSelector v-model="cost.cost_type" @change="onCostTypeChange" />
                    <template #description>
                      <GekkoButton 
                        @click="redirectCostTypes" 
                        :text="$gettext('Add cost categories')" 
                        icon="fa-solid fa-plus" 
                        class="text-info p-0 w-100 whitesp-normal"
                        size="sm"
                        variant="link"
                      />
                    </template>
                  </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Customer')" label-for="input-10">
              <b-form-group>
                <CustomerSelector v-model="cost.customer" @change="customerCallback" :filters="{is_customer:'True', owner_company: currentCompany.id, is_archived:'False'}" />
              </b-form-group>
            </b-form-group>
            <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Project')" label-for="input-10">
              <b-form-select v-model="cost.project" :disabled="projectList.length === 0">
                <b-form-select-option v-for="project in projectList" :value="project.id" :key="project.id">
                  {{project.name}}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <CostTransactions :costId="cost.id" />
          </div>
        </overlay-scrollbars>
        
      </div> <!-- mastermodal-view--left end -->

      <div class="mastermodal-view--right modal-dropzone-actions" :class="{ 'expanded': previewExpanded }">
        <div class="mastermodal-view--right__handle" @click="previewExpanded = !previewExpanded"/>
        <div class="mastermodal-view--right__document">
          
          <div class="modal-dropzone-actions--wrap">
            <div class="modal-main-actions">
              <SmartScanSwitch @change="onSmartScanChange" />
              <div v-if="scanning || emptyScan" class="w-100">
                <ProgressBar v-if="scanning" class="w-50 ml-3" />
                <div class="hint" v-if="emptyScan">We could not find any data. Try again or upload a different file.</div>
              </div>
            </div>
            <div class="modal-dropzone-wrapper">
              <VueDropzone :preloaded_file="imageSrc" :allowed-files="'all'" :onlyChange="true" @change="fileChanged" />
            </div>
          </div>
          
        </div> <!-- mastermodal-view--right__document end -->

        <div class="mastermodal-view--right__statuswrap">
          <CostStatusBadge :cost="cost" @toggle-complete="toggleComplete" />
        </div> <!--  mastermodal-view--right__statuswrap end -->
      </div> <!-- mastermodal-view--right end -->
    </div> <!-- mastermodal-view-wrap end -->

  </b-form>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import costs from "@/mixins/costs"

import VueDropzone from "@/components/VueDropzone";
import PaymentTypeSelector from "@/components/costs/PaymentTypeSelector";
import CostTypeSelector from "@/components/costs/CostTypeSelector";
import CustomerSelector from "@/components/CustomerSelector";
import SmartScanSwitch from "@/components/SmartScanSwitch";
import CostTransactions from "@/components/costs/CostTransactions";
import ProgressBar from "@/components/ui/ProgressBar";
import GekkoButton from "@/components/GekkoButton";
import TimelineWidget from "@/components/dashboard/widgets/TimelineWidget";
import CostStatusBadge from "@/components/costs/ui/CostStatusBadge"
import CompanyService from "@/store/services/company.service.js";
import CostService from "@/store/services/cost.service.js";
import CustomerService from "@/store/services/customer.service.js";

import NumberInput from "@/components/ui/NumberInput"

export default {
  name: "EditCost",
  mixins: [costs],
  components: {
    GekkoButton, VueDropzone, PaymentTypeSelector, CustomerSelector, CostTypeSelector, SmartScanSwitch,
    CostTransactions, ProgressBar, TimelineWidget, 
    CostStatusBadge, NumberInput
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    viewTabs: {
      type: Boolean,
      default: true
    },
    forceCostId: {
      type: Number,
      default: null
    },
    transactionCost: {
      type: Object,
      default: () => {}
    },
    emitSubmit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cost: {},

      detailView: 'details',

      loading: true,
      isSaving: false,

      showAIfieldsDate: false,
      showAIfieldsSupplier: false,
      showAIfieldsVAT: false,
      showAIfieldsAmount: false,
      isTestingMode: false,
      scanning: false,

      imageSrc: null,

      tax_rates: [],
      projectList: [],

      emptyScan: false,
      costtypeObject: {},
      firstCosttypeLoad: true,

      previewExpanded: false
    }
  },
  computed: {
    ...mapGetters ({
      currentUser: 'main/getCurrentUser',
      currentUserProfile: 'main/getCurrentUserProfile',
      currentCompany: 'main/getCurrentCompany',
      storeCost: 'costs/getCost',
      taxRates: 'costs/getCompanyTaxRates',
      getCostNumber: 'costs/getCostNumber',
      visitingCompanyId: 'main/getVisitingCompanyId'
    }),
    filterTaxRates () {
      var out = [];
      for (var i in this.taxRates) {
        if (new Date(this.taxRates[i].start_date) < new Date(this.cost.date) && new Date(this.taxRates[i].end_date) > new Date(this.cost.date)) {
          out.push(this.taxRates[i]);
        }
      }
      return out;
    }
  },
  watch: {
    cost: {
      handler () {
        if (!this.loading) {
          // update store cost to save it
          this.setCost(this.cost)
          this.$emit('unsaved-changes', false)
        }
      },
      deep: true
    }
  },
  created () {
    this.loading = true
    this.smartScan = this.currentUserProfile.smart_scan

    // passing costId directly as a prop instead of :costId url parameter
    if (this.forceCostId) {
      this.loadCost(this.forceCostId).then(() => {
        this.setupData()
      })
    } else {
      this.setupData()
    }

  },
  methods: {
    ...mapActions({
      loadCost: 'costs/loadCost',
      getNextCostNumber: 'costs/getNextCostNumber'
    }),
    ...mapMutations({
      setCost: 'costs/SET_COST'
    }),
    setupData () {
      // if (this.$route.name === "EditCost" || this.$route.name === "BalanceSheetEditCost" || this.$route.name === "ControlPanelEditCost" || this.forceCostId) {
      
      // EDIT
      if (this.isEdit && this.storeCost) {
        this.cost = Object.assign({}, this.storeCost)
        this.imageSrc = (this.cost.image) ? this.cost.image : null
        this.handleCostLines()
        // next tick to cost watcher is not triggered immediately
          this.$nextTick(() => {
            this.loading = false
          })
      } else { 
        // CREATE

        const new_cost_date = new Date().format('Y-m-d')
        this.getNextCostNumber(new_cost_date.split('-')[0]).then(() => {
          this.setCostCreateDefaults()

          this.firstCosttypeLoad = false;

          this.handleCostLines()
          // next tick to cost watcher is not triggered immediately
          this.$nextTick(() => {
            this.loading = false
          })
        })
      }
      
    },
    setCostCreateDefaults () {
      this.cost = {
        amount: '',
        btw_reversed_charge: false,
        cost_lines: [],
        cost_type: null,
        created_by: this.currentUser.id,
        customer: null,
        date: new Date().format('Y-m-d'),
        description: "",
        id: null,
        image: null,
        number: this.getCostNumber,
        number_on_document: "",
        owner_company: this.visitingCompanyId,
        payment_type: "bank",
        project: null,
        retention_tax_amount: 0,
        retention_tax_percentage: 0,
        subtotal_amount: '',
        supplier: null,
        tax_exempt: false,
        total_tax: 0,
        marked_as_completed: false,
      }

      if (this.$route.path.includes('control-panel')) {
        const new_cost_date = new Date().format('Y-m-d')
        CostService.getNextCostNumberByCompanyId({ 'year': new_cost_date.split('-')[0]}, this.visitingCompanyId).then((response) => {
          this.$store.commit('costs/SET_COST_NUMBER', response.data)
          this.cost.number = response.data
        })
      }

      if (this.transactionCost) {
        this.cost.amount = parseFloat(Math.abs(this.transactionCost.amount))
        this.cost.date = this.transactionCost.date
        this.cost.description = this.transactionCost.description
      }
    },
    onSubmit (e = null) {
      this.isSaving = true
      if (e) e.preventDefault()
      this.saveCost()
    },
    saveCost () {
      for (var propName in this.cost) {
        if (this.cost[propName] === null || this.cost[propName] === undefined) {
          delete this.cost[propName]
        }
      }

      if (this.cost.cost_lines.length === 0) {
        delete this.cost.cost_lines
      }

      var cost = this.prepareCostForUpload(this.cost) // mixins

      if (this.$route.name === "EditCost" || this.$route.name === "BalanceSheetEditCost" || this.$route.name === "ControlPanelEditCost" || this.forceCostId) { 
        // EDIT
        CostService.update(cost.id, cost).then( (response) => {

          this.cost.image = response.data.image

          this.$store.commit('setAlert', {
            title: this.$gettext("Cost Updated"),
            text: this.$gettext("Successfully edited cost"),
            variant: "success",
            duration: 4
          })

          this.$emit('edited', response.data)

        }).catch( (response) => {
          this.saveError(response)                        
        })
      } else {
        // CREATE
        CostService.create(cost).then( (response) => {

          this.$store.commit('setAlert', {
            title: this.$gettext("Cost Created"),
            text: this.$gettext("Successfully created cost"),
            variant: "success",
            duration:4
          })

          this.$emit('created', response.data)
        }).catch( (response) => {
          this.saveError(response)                        
        })
      }
    },
    saveError (response) {
      this.isSaving = false
      if (response && response.non_field_errors && response.non_field_errors[0] === 'The fields number, owner_company must make a unique set.') {
        this.$store.commit('setAlert', {
          title: this.$gettext("Error"),
          text: this.$gettext("Cost not saved, cost number already in use."),
          variant: "danger",
          duration: 4
        })
      } else {
        this.$store.commit('setAlert', {
          title: this.$gettext("Error"),
          text: this.$gettext("Something went wrong, cost is not saved."),
          variant: "danger",
          duration: 4
        })
      }
    },
    toggleComplete () {
      this.$set(this.cost, 'marked_as_completed', !this.cost.marked_as_completed)
    },
    calculate (cost_line) {
      for (let i in this.cost.cost_lines) {
        this.cost.cost_lines[i].amount = "";
      }
      let vat;
      if (this.currentCompany.country === 'ES') {
        if (this.cost.subtotal_amount) {
          vat = cost_line.tax_rate / 100 * this.cost.subtotal_amount;
          vat = vat.toFixed(2);
        }
        cost_line.amount = parseFloat(vat);
      } else {
        if (this.cost.amount) {
          var vatFactor = cost_line.tax_rate / 100;
          var base = parseFloat(this.cost.amount) / (1 + vatFactor);
          vat = (base * vatFactor).toFixed(2);
        }
        cost_line.amount = parseFloat(vat);
      }
    },
    calculateRetentionAmount () {
      if (!this.cost.retention_tax_percentage || !this.cost.subtotal_amount) return;
      this.cost.retention_tax_amount = -parseFloat((Math.round(this.cost.retention_tax_percentage * this.cost.subtotal_amount) / 100).toFixed(2));
    },
    onSmartScanChange () {
      this.smartScan = !this.smartScan;
      this.scanning = false;
      if (this.smartScan && this.cost.image) {
        this.doScan(this.cost.image)
      }
    },
    redirectCostTypes () {
      // TODO use vue router
      window.location.href = window.Urls['accounts_costtypes_settings']()
    },
    fileChanged (file) {
      if (this.smartScan && (this.$store.getters['getIsPremium'] || this.currentUser.is_accountant) && file) {
        this.doScan(file)
      }
      this.cost.image = file
    },
    doScan (file) {
      this.emptyScan = false
      this.scanning = true
      window.processCostFile(file).then( (googleResponse) => {
        if(googleResponse && Object.keys(googleResponse.responses[0]).length > 0){
          this.handleGoogleResponse(googleResponse)
        } else {
          this.emptyScan = true
        }
        this.scanning = false
      }).catch(() => {
        this.scanning = false;
        this.emptyScan = true;
      })
    },
    handleGoogleResponse (googleResponse) {
      var tax1 = 0;
      var tax2 = 0;
      var tax3 = 0;

      if (this.cost.cost_lines.length===1) {
        tax1 = this.cost.cost_lines[0].tax_rate
      } else if (this.cost.cost_lines.length === 2) {
        tax1 = this.cost.cost_lines[0].tax_rate
        tax2 = this.cost.cost_lines[1].tax_rate
      } else if (this.cost.cost_lines.length > 2) {
        tax1 = this.cost.cost_lines[0].tax_rate
        tax2 = this.cost.cost_lines[1].tax_rate
        tax3 = this.cost.cost_lines[2].tax_rate
      }
      var retention = 0
      if (this.cost.retention_tax_percentage) {
        retention = this.cost.retention_tax_percentage
      }
      if (this.isTestingMode) {
        var canvas = document.getElementById('ocr-canvas');
        canvas.style.display = "block";
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = "rgba(255, 0, 0, 0.5)";
        googleResponse.responses[0].textAnnotations.forEach((element, index) => {
          if (index>0) {
            var v = element.boundingPoly.vertices;
            ctx.beginPath();
            ctx.moveTo(v[0].x, v[0].y);
            ctx.lineTo(v[1].x, v[1].y);
            ctx.lineTo(v[2].x, v[2].y);
            ctx.lineTo(v[3].x, v[3].y);
            ctx.fill();
          }
        })
      }
      let ocrResponse = window.analyzeJSON(googleResponse, this.currentCompany.country, tax1, tax2, tax3, retention);
      if (ocrResponse['dateCandidates'].length > 0) {
        this.showAIfieldsDate = true;
        this.cost.date = new Date(ocrResponse['dateCandidates'][0].value * 1000).format("Y-m-d");
      }
      if (ocrResponse['taxAmount1Candidates'].length > 0) {
        this.showAIfieldsVAT = true;
        this.cost.cost_lines[0].amount = ocrResponse['taxAmount1Candidates'][0].value;
      }
      if (ocrResponse['taxAmount2Candidates'].length > 0) {
        this.showAIfieldsVAT = true;
        this.cost.cost_lines[1].amount = ocrResponse['taxAmount2Candidates'][0].value;
      }
      if (ocrResponse['taxAmount3Candidates'].length > 0) {
        this.showAIfieldsVAT = true;
        this.cost.cost_lines[2].amount = ocrResponse['taxAmount3Candidates'][0].value;
      }
      if (ocrResponse['totalAmountCandidates'].length > 0) {
        this.showAIfieldsAmount = true;
        if (this.currentCompany.country === 'ES') {
          var amount = ocrResponse['totalAmountCandidates'][0].value;
          var subtotal_amount = amount - this.cost.cost_lines[0].amount - this.cost.cost_lines[1].amount - this.cost.cost_lines[2].amount;
          this.cost.subtotal_amount = Math.round(subtotal_amount*100)/100;
        } else {
          this.cost.amount = ocrResponse['totalAmountCandidates'][0].value;

          // if (!this.transactionCost) {
          //     this.cost.amount = ocrResponse['totalAmountCandidates'][0].value;
          // } else {
          //     this.cost.amount = this.transactionCost.amount
          // }
        }
      }
      if (ocrResponse['supplierCandidates'].length > 0) {
        let body = {
          "company_id": this.visitingCompanyId,
          "supplierCandidates": ocrResponse['supplierCandidates']
        }
        CostService.selectSupplierCandidate(body).then((response) => {
          if (response.status === 200) {
            this.cost.supplier = response.data.id;
            this.showAIfieldsSupplier = true;
          }
        });
      }
    },
    showField (fieldname) {
      var fields = {};
      fields['ES'] = ['number_on_document', 'subtotal_amount', 'retention'];
      fields['NL'] = ['amount',];
      var country = this.currentCompany.country;
      if(!(country in fields)){
        country = "NL";
      }
      if (fields[country].includes(fieldname)) {
        return true;
      }
      return false;
    },
    handleCostLines () {
      for (var i = 0; i < this.filterTaxRates.length; i++) {
        var a_line = this.filterTaxRates[i];
        var cost_line = this.cost.cost_lines.find(element => element.tax_rate === a_line.taxrate)
        if (!cost_line) {
          if (a_line.taxrate>0) {
            this.cost.cost_lines.push({ tax_rate: a_line.taxrate, amount: '' })
          }
        }
      }
      this.cost.cost_lines = this.cost.cost_lines.sort((a, b) => (a.tax_rate > b.tax_rate) ? -1 : ((b.tax_rate > a.tax_rate) ? 1 : 0))
    },

    costNumberChange (value) {
      this.$store.commit('costs/setCostNumber', value);
    },

    customerCallback (customer_id) {
      if (!customer_id) {
        this.cost.customer = null
        this.cost.project = null
        return
      }
      return CustomerService.retrieve(customer_id, { extended: true }).then((response) => {
        this.projectList = response.data.projects.filter(project => project.is_archived === false)
        this.projectList.unshift({ name: this.$gettext('Nothing Selected'), id: null })
        for (var i = 0; i < this.projectList.length; i++) {
          if (this.projectList[i].id === this.cost.project) {
            return
          }
        }
        this.cost.project = null
      })
    },

    disableTaxFields () {
      var fields_disabled = this.cost.btw_reversed_charge || this.cost.tax_exempt || (this.costtypeObject && this.costtypeObject.vat_deductible===false);
      if (fields_disabled) {
        for (var i = 0; i < this.cost.cost_lines.length; i++) {
          this.cost.cost_lines[i].amount = '';
        }
      }
      return fields_disabled;
    },
    onCostTypeChange (option) {
      if (this.firstCosttypeLoad) {
        this.firstCosttypeLoad = false;
        return;
      }
      // let prevOption = this.costtypeObject;
      this.costtypeObject = option;
      this.disableTaxFields();
      if (this.costtypeObject && this.costtypeObject.vat_deductible) {
        // this.cost.tax_exempt = false;
        // if (prevOption.vat_deductible === false)
        //     this.cost.btw_reversed_charge = false;
      } else {
        this.cost.tax_exempt = true;
        this.cost.btw_reversed_charge = false;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
  .modal-cost-view-wrap {
    height: 100%;
    .mastermodal-view-tabs {
      &--details {
        padding: 1rem;
      }
    }

    .mastermodal-view {
      &--right {
        &__document {
          display: block;
          background: transparent;
        }
        &__statuswrap {
          padding: 0;
        }
      }
    }
    @media (min-width: '768px') {
      .mastermodal-view {
        &--right {
          padding: 1rem;
        }
      }
    }

    .modal-dropzone-actions {
      .modal-dropzone-actions--wrap {
        margin-bottom: 20px; 
        .modal-dropzone-wrapper {
          flex: 1;
          height: calc(100% - 50px) !important; // smartScan height + margin top
          margin-top: 10px;
        }
      }
    }

  }

  .modal-content {
    height: 100%;
    overflow: hidden;
    .contact-tabs {
      height: 100%;
      .tab-content {
        height: 100%;
        .os-host-overflow-y {
          padding-right: 1rem;
        }
      }
    }
  }
</style>

<style lang="scss">

</style>